<template>
    <AuthLayout  show-legal bg-image="register-view">
        <div class="flex gap-9">
            <div class="register-form" @keyup.enter="register">
                <div class="mb-2 pb-4 border-b dark:border-neutral-700">
                    <div class="flex items-center mb-2">
                        <p class="font-bold grow">Tvorba účtu MAEUM</p>
                        <div class="bg-account-logo dark:brightness-200 dark:contrast-200 dark:grayscale dark:invert bg-contain bg-center bg-no-repeat w-[120px] h-[30px]"></div>
                    </div>
                    <p class="text-sm text-gray-500 dark:text-gray-300">V tomto kroku vytvoříte účet MAEUM, kterým se poté budete přihlašovat do Roori. Účet MAEUM je zdarma a dovolí vám využívat další služby MAEUM.</p>
                </div>
                <div class="input-el">
                    <InputText id="name" type="text" class="w-100" v-model="form.name" @change="form.validate('name')" :invalid="form.invalid('name')"
                               placeholder="Jméno" />
                    <small id="name-help">{{ form.errors['name']  }}</small>
                </div>
                <div class="input-el">
                    <InputText id="email" type="email" class="w-100" v-model="form.email" @change="form.validate('email')" :invalid="form.invalid('email')"
                               placeholder="E-mail" />
                    <small id="email-help">{{ form.errors['email']  }}</small>
                </div>
                <div class="input-el">
                    <InputText id="password" type="password" class="w-100" @change="form.validate('password')" v-model="form.password"
                               :invalid="form.invalid('password')" placeholder="Heslo" />
                    <small id="password-help">{{ form.errors['password'] }}</small>
                </div>
                <div class="input-el">
                    <InputText id="c_password" type="password" class="w-100" @change="form.validate('c_password')" v-model="form.c_password"
                               :invalid="form.invalid('c_password')" placeholder="Zopakujte heslo" />
                    <small id="c_password-help">{{ form.errors['c_password']  }}</small>
                </div>

                <p>Registrací souhlasíte s <a :href="`${$page.props.olympus.account_url}/contracts/contract/Vq`" target="_blank" class="text-blue-600 after:content-['_↗']">licenčním ujednáním účtu MAEUM</a>.</p>
                <div class="text-center">
                    <Button label="Registrovat a přejít na objednávku" @click="register" :loading="form.processing"></Button>
                </div>
            </div>
            <div v-if="false" class="border-l w-1/2 pl-9 flex flex-col">
                <p class="font-bold mb-4">Máte již účet MAEUM?</p>
                <div class="border rounded-xl p-5 grow bg-neutral-50 shadow">
                    <InputText id="email" placeholder="E-mail" type="email" class="w-full" v-model="form.email"
                               :invalid="$page.props.errors.email !== undefined" />
                    <small v-if="$page.props.errors.email !== undefined" class="text-red-500 -mt-2">{{$page.props.errors.email}}</small>
                    <InputText id="password" placeholder="Heslo" type="password" class="w-full" v-model="form.password"
                               :invalid="$page.props.errors.password !== undefined" />
                    <small v-if="$page.props.errors.password !== undefined" class="text-red-500 -mt-2">{{$page.props.errors.password}}</small>
                    <div class="form-buttons">
                        <Button label="Přihlásit se" class="w-full"></Button>
                    </div>
                </div>
            </div>
        </div>
    </AuthLayout>
</template>
<script setup>
    import Button from 'primevue/button';
    import InputText from 'primevue/inputtext';
    import Checkbox from 'primevue/checkbox';
    import AuthLayout from '../components/view-components/AuthLayout.vue';
    import {useForm} from "laravel-precognition-vue-inertia";
    import {router, usePage} from "@inertiajs/vue3";
    const form = useForm('post', '/register/' + usePage().props.plan.slug,{
        name: '',
        email: '',
        password: '',
        c_password: ''
    });
    const register = () => {
        form.submit();
    }
</script>
<style lang="scss" scoped>
    .register-form {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .input-el {
            display: flex;
            flex-direction: column;

            small {
                color: red;
                margin-top: 6px;
            }

            &.horizontal {
                flex-direction: row;
                gap: 12px;
                font-size: .925rem;
            }
        }

        .form-buttons {
            display: flex;
            gap: 8px;
        }
    }
</style>
